'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoodsSlider = undefined;

var _GoodsSlider2 = require('./GoodsSlider');

var _GoodsSlider3 = _interopRequireDefault(_GoodsSlider2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.GoodsSlider = _GoodsSlider3.default; /**
                                              * Created by maximus on 30.12.16.
                                              */


//////////////////
// WEBPACK FOOTER
// ./src/components/GoodsSlider/index.js
// module id = 1666
// module chunks = 0